import React from "react";
import ViewResources from "../../pages/resources/ViewResources";
import CreateEditResources from "../../features/resources/CreateEditResources";
import CpdSubmission from "../../pages/cpd/cpdSubmission/CpdSubmission";
import ApproveCpdSubmission from "../../pages/cpd/verifyCpdSubmission/ApproveCpdSubmission";
import PreviewResources from "../../features/resources/PreviewResources";
import GmapPricingTable from "../../pages/gmap/gmapPricingTable/GmapPricingTable";
import ViewIndividualMembers from "../../pages/gmap/viewIndividualMembers/ViewIndividualMembers";
import GmapApplicationTasklist from "../../pages/gmap/gmapApplicationTasklist/GmapApplicationTasklist";
import GmapApplicationTaskListNewApplication from "../../pages/gmap/gmapApplicationTasklist/gmapApplicationTaskListNewApplication/GmapApplicationTaskListNewApplication";
import MemberDirectory from "../../pages/membership/memberDirectory/MemberDirectory";
import EditIndividualMembers from "../../pages/gmap/viewIndividualMembers/EditIndividualMembers";
import EditEmailTemplate from "../../pages/fieldMaintenance/emailTemplateManagement/EditEmailTemplate";
import DropdownManagement from "../../pages/fieldMaintenance/dropdownManagement/DropdownManagement";
import AddEmailTemplate from "../../pages/fieldMaintenance/emailTemplateManagement/AddEmailTemplate";
import EmailTemplateManagement from "../../pages/fieldMaintenance/emailTemplateManagement";
import CreateIndividualMembers from "../../pages/gmap/viewIndividualMembers/createIndividualMembers";
import CreatePages from "../../pages/pageManagement/createPages/CreatePages";
import ViewPages from "../../pages/pageManagement/viewPages/ViewPages";
import EditableGridPage from "../../pages/EditableGrid/EditableGridPage";
import GmapDiscretionaryRenewalTaskList from "../../pages/gmap/gmapDiscretionaryRenewalTaskList/GmapDiscretionaryRenewalTaskList";
import gmapDiscretionaryRenewalRequest from "../../pages/gmap/gmapDiscretionaryRenewalRequest/gmapDiscretionaryRenewalRequest";
import EditDiscretionaryrenewalRequest from "../../features/gmap/DiscretionaryRenewalRequest/Components/EditDiscretionaryrenewalRequest";
import EditDiscretionaryRenewalTaskListApplication from "../../features/gmap/DiscretionaryRenewalTaskList/EditDiscretionaryRenewalTaskListApplication";
import GMACourse from "../../pages/gmaCourse/gmaCourse";
import cpdUpload from "../../pages/cpd/cpdUpload/cpdUpload";
import CKEditorForm from "../../pages/CkEditor/CKEditorForm";
import CpdRenewalCycle from "../../pages/cpd/cpdRenewalCycle/CpdRenewalCycle";
import XeroBatchExtraction from "../../pages/Financials/xeroBatchExtraction/XeroBatchExtraction";
import EventManagement from "../../pages/eventManagement/EventManagement";
import ViewEditEventManagement from "../../pages/eventManagement/ViewEditEventManagement";
import EventRegistrationApproval from "../../pages/eventManagement/EventRegistrationApproval";
import EventFeedbackQuestion from "../../pages/eventManagement/EventFeedbackQuestion";
import EventQuestionAnswer from "../../pages/eventManagement/EventQuestionAnswer";
import TransactionReport from "../../pages/Financials/TransactionReport/TransactionReport";
import AccountManagement from "../../pages/accountManagement/accountManagement/AccountManagement";
import ViewAccountTaskList from "../../features/Accountmanagement/ViewAccountManagement/ViewAccountManagementList";
import GmpCourseProviderTaskListApplication from "../../pages/gmpCourseProvider/gmpCourseProviderTaskListApplication/GmpCourseProviderTaskListApplication";
import GmpCourseProviderApplicationTaskList from "../../pages/gmpCourseProvider/GmpCourseProviderApplicationTaskList";
import CommitteeApprovalAssignment from "../../pages/committeeList/committeeApprovalAssignment/CommitteeApprovalAssignment";
import CommitteeBatchApproval from "../../pages/committeeList/committeeBatchApproval/CommitteeBatchApproval";
import ViewCommitteeBatchApproval from "../../pages/committeeList/viewCommitteeBatchApproval/ViewCommitteeBatchApproval";
import CommitteApprovalManagement from "../../pages/committeApprovalManagement/CommitteeApprovalManagement";
import CpdEventApplication from "../../pages/gmpCourseProvider/cpdEventApplication/CpdEventApplication";
import AttendanceSubmissionApprovalList from "../../pages/attendanceSubmission/ApproveAttendanceSubmissionList";
import ViewCpdAttendance from "../../pages/viewCpdAttendance/ViewCpdAttendance";
import AddManualAttendance from "../../pages/gmpCourseProvider/addManualAttendance/AddManualAttendanceList";
import ViewManualAccount from "../../pages/accountManagement/viewManualAccount/[...memberId]";
import ViewManualAccountList from "../../pages/accountManagement/viewManualAccountList/ViewManualAccountList";
import CreateManualAccount from "../../pages/accountManagement/createManualAccount/CreateManualAccount";
import GreenMarkProject from "../../pages/greenMarkProject/GreenMarkProject";
// import editGreenMarkProject from "../../pages/greenMarkProject/editGreenMarkProject/[...editId]";
import EditGmProject from "../../pages/greenMarkProject/editGreenMarkProject/EditGmProject";
import GmpCourseTaskList from "../../pages/gmpCourseProvider/gmpCourseView/GmpCourseTaskList";
import EditGMPCourse from "../../pages/gmpCourseProvider/gmpCourseView/EditGMPCourse";
import VerifiedCompetency from "../../pages/verifiedCompetency/VerifiedCompetency";
import AddVerifiedCompetency from "../../pages/AddVerifiedCompetency/AddVerifiedCompetency";
import VerifiedCompetencySubmission from "../../pages/verifiedCompetencySubmission/[...editId]";
import MetabaseDashBoard from "../../pages/metabaseDashBoard/MetabaseDashBoard";
import MetabaseReport1 from "../../pages/metabaseDashBoard/MetabaseReport1";
import MetabaseReport2 from "../../pages/metabaseDashBoard/MetabaseReport2";
import MetabaseReport3 from "../../pages/metabaseDashBoard/MetabaseReport3";
import MetabaseReport4 from "../../pages/metabaseDashBoard/MetabaseReport4";
import MetabaseReport5 from "../../pages/metabaseDashBoard/MetabaseReport5";
import MetabaseReport6 from "../../pages/metabaseDashBoard/MetabaseReport6";

const NotFound = React.lazy( () => import( "../../pages/errors/NotFound" ) );
const Dashboard = React.lazy( () => import( '../../pages/dashboard/Dashboard' ) );


export const ComponentNavigation = [
  {
    id: 'dashboard',
    path: '/',
    exact: true,
    title: 'Dashboard',
    component: Dashboard,
    hasParams: false,
    text: 'Dashboard',
    securityKey: ""
  },
  {
    id: 'metabaseReport',
    path: '/metabaseReport',
    exact: true,
    title: 'List of Course Provider',
    component: MetabaseDashBoard,
    hasParams: false,
    text: 'List of Course Provider',
    securityKey: ""
  },
  {
    id: 'metabaseReport1',
    path: '/metabaseReport1',
    exact: true,
    title: 'CPD Events held during specific date',
    component: MetabaseReport1,
    hasParams: false,
    text: 'CPD Events held during specific date',
    securityKey: ""
  },
  {
    id: 'metabaseReport2',
    path: '/metabaseReport2',
    exact: true,
    title: 'List of GMPs',
    component: MetabaseReport2,
    hasParams: false,
    text: 'List of GMPs',
    securityKey: ""
  },
  {
    id: 'metabaseReport3',
    path: '/metabaseReport3',
    exact: true,
    title: 'Monthly GMP Applications',
    component: MetabaseReport3,
    hasParams: false,
    text: 'Monthly GMP Applications',
    securityKey: ""
  },
  {
    id: 'metabaseReport4',
    path: '/metabaseReport4',
    exact: true,
    title: 'Approved GMPs',
    component: MetabaseReport4,
    hasParams: false,
    text: 'Approved GMPs',
    securityKey: ""
  },
  {
    id: 'metabaseReport5',
    path: '/metabaseReport5',
    exact: true,
    title: 'GMP Yearly Reporting',
    component: MetabaseReport5,
    hasParams: false,
    text: 'GMP Yearly Reporting',
    securityKey: ""
  },
  {
    id: 'approvedCPDactivities',
    path: '/approvedCPDactivities',
    exact: true,
    title: 'CPD Activities Reporting',
    component: MetabaseReport6,
    hasParams: false,
    text: 'CPD Activities Reporting',
    securityKey: ""
  },
  {
    id: "pageNotFound",
    path: "pageNotFound",
    exact: true,
    title: "",
    component: NotFound,
    text: "Page not found",
    securityKey: ""
  },
  {
    id: 'gmapPricingTable',
    path: '/gmapPricingTable',
    exact: true,
    title: 'GMAP Pricing Table',
    component: GmapPricingTable,
    hasParams: false,
    text: 'GMAP Pricing Table',
    securityKey: ""
  },
  {
    id: 'createNewIndividualMember',
    path: '/createNewIndividualMember',
    exact: true,
    title: 'Create Individual Member',
    component: CreateIndividualMembers,
    hasParams: false,
    text: 'Create Individual Member',
    securityKey: ""
  },
  {
    id: 'viewIndividualMembers',
    path: '/viewIndividualMembers',
    exact: true,
    title: 'View Individual Members',
    component: ViewIndividualMembers,
    hasParams: false,
    text: 'View Individual Members',
    securityKey: ""
  },
  {
    id: 'gmaCourse',
    path: '/gmaCourse',
    exact: true,
    title: 'GMA - GMA Course Backend',
    component: GMACourse,
    hasParams: false,
    text: 'GMA - GMA Course Backend',
    securityKey: ""
  },
  {
    id: 'editIndividualMembers',
    path: '/EditIndividualMembers/:id',
    exact: true,
    // title: 'Edit Individual Member',
    component: EditIndividualMembers,
    hasParams: false,
    text: 'Edit Individual Member',
    securityKey: ""
  },
  {
    id: 'gmapApplicationTasklist',
    path: '/gmapApplicationTasklist',
    exact: true,
    title: 'GMP Application Task List',
    component: GmapApplicationTasklist,
    hasParams: false,
    text: 'GMP Application Task List',
    securityKey: ""
  },
  {
    id: 'gmapApplicationTaskListNewApplication',
    path: '/gmapApplicationTaskListNewApplication',
    exact: true,
    title: 'GMAP Application Task List (New Application)',
    component: GmapApplicationTaskListNewApplication,
    hasParams: false,
    text: 'GMAP Application Task List (New Application)',
    securityKey: ""
  },
  {
    id: 'editApplicationTaskList',
    path: '/EditApplicationTaskList/:id/:taskListId',
    exact: true,
    title: 'Edit GMAP Application Task List',
    component: GmapApplicationTaskListNewApplication,
    hasParams: true,
    text: 'Edit GMAP Application Task List',
    securityKey: ""
  },
  {
    id: 'gmapApplicationTaskListDiscretionaryRenewal',
    path: '/gmapApplicationTaskListDiscretionaryRenewal',
    exact: true,
    title: 'GMAP Discretionary Renewal Task List (Renewal)',
    component: GmapDiscretionaryRenewalTaskList,
    hasParams: false,
    text: 'GMAP Discretionary Renewal Task List (Renewal)',
    securityKey: ""
  },
  {
    id: 'editApplicationTaskListDiscretionaryRenewal',
    path: '/editDiscretionaryRenewalTaskListApplication/:id/:taskListId',
    exact: true,
    title: 'Edit GMAP Discretionary Renewal Task List (Renewal)',
    component: EditDiscretionaryRenewalTaskListApplication,
    hasParams: false,
    text: 'Edit GMAP Discretionary Renewal Task List (Renewal)',
    securityKey: ""
  },
  {
    id: 'gmapDiscretionaryRenewalRequest',
    path: '/gmapDiscretionaryRenewalRequest',
    exact: true,
    title: 'GMAP Discretionary Renewal Request',
    component: gmapDiscretionaryRenewalRequest,
    hasParams: false,
    text: 'GMAP Discretionary Renewal Request',
    securityKey: ""
  },
  {
    id: 'editDiscretionaryRenewalRequest',
    path: '/editDiscretionaryRenewalRequest/:memberId/:requestId',
    exact: true,
    title: 'Edit GMAP Discretionary Renewal Request',
    component: EditDiscretionaryrenewalRequest,
    hasParams: false,
    text: 'Edit GMAP Discretionary Renewal Request',
    securityKey: ""
  },
  // cpd dropdown start
  {
    id: 'approveCpdSubmission',
    path: '/approveCpdSubmission',
    exact: true,
    title: 'Approve CPD Submission',
    component: ApproveCpdSubmission,
    hasParams: false,
    text: 'Approve CPD Submission',
    securityKey: ""
  },
  {
    id: 'cpdSubmission',
    path: '/cpdSubmission/:id',
    exact: true,
    title: 'CPD Submission',
    component: CpdSubmission,
    hasParams: false,
    text: 'CPD Submission',
    securityKey: ""

  },
  {
    id: 'cpdUpload',
    path: '/cpdUpload',
    exact: true,
    title: 'CPD Upload',
    component: cpdUpload,
    hasParams: false,
    text: 'CPD Upload',
    securityKey: ""
  },
  {
    id: 'cpdRenewalCycle',
    path: '/cpdRenewalCycle',
    exact: true,
    title: 'CPD Renewal Cycle',
    component: CpdRenewalCycle,
    hasParams: false,
    text: 'CPD Renewal Cycle',
    securityKey: ""
  },
  // cpd dropdown end
  {
    id: 'viewResources',
    path: '/viewResources',
    exact: true,
    title: 'View Resources',
    component: ViewResources,
    hasParams: false,
    text: 'View Resources',
    securityKey: ""
  },
  {
    id: 'createEditResources',
    path: '/createEditResources',
    exact: true,
    title: 'Create/Edit Resources',
    component: CreateEditResources,
    hasParams: false,
    text: 'Create/Edit Resources',
    securityKey: ""
  },
  {
    id: 'previewResources',
    path: '/previewResources',
    exact: true,
    title: 'Preview',
    component: PreviewResources,
    hasParams: false,
    text: 'Preview',
    securityKey: ""
  },
  // Resources Pages End
  // membership dropdown start
  {
    id: 'memberDirectory',
    path: '/memberDirectory',
    exact: true,
    title: 'Member Directory',
    component: MemberDirectory,
    hasParams: false,
    text: 'Member Directory',
    securityKey: ""
  },

  //Field Maintanance
  {
    id: 'emailTemplateManagement',
    path: '/emailTemplateManagement',
    exact: true,
    title: 'Email Template Management',
    component: EmailTemplateManagement,
    hasParams: false,
    text: 'Email Template Management',
    securityKey: ""
  },
  {
    id: 'editEmailTemplateManagement',
    path: '/emailTemplateManagement/:id',
    exact: true,
    title: 'Email Template Management',
    component: EditEmailTemplate,
    hasParams: false,
    text: 'Edit Email Template Management',
    securityKey: ""
  },
  {
    id: 'addEmailTemplate',
    path: '/emailTemplateManagement/addEmailTemplate',
    exact: true,
    title: 'Add Email Template',
    component: AddEmailTemplate,
    hasParams: false,
    text: 'Add Email Template',
    securityKey: ""
  },
  {
    id: 'dropdownManagement',
    path: '/dropdownManagement',
    exact: true,
    title: 'Dropdown Management',
    component: DropdownManagement,
    hasParams: false,
    text: 'Dropdown Management',
    securityKey: ""
  },
  {
    id: 'editableGridPage',
    path: '/editableGridPage',
    exact: true,
    title: 'Editable Grid Pages',
    component: EditableGridPage,
    hasParams: false,
    text: 'Editable Grid Pages',
    securityKey: ""
  },



  //Field Maintanance end

  // page Management

  {
    id: 'createPages',
    path: '/createPages',
    exact: true,
    title: 'Create Pages',
    component: CreatePages,
    hasParams: false,
    text: 'Create Pages',
    securityKey: ""
  },
  {
    id: 'viewPages',
    path: '/viewPages',
    exact: true,
    title: 'View Pages',
    component: ViewPages,
    hasParams: false,
    text: 'View Pages',
    securityKey: ""
  },
  {
    id: 'ckEditorTest',
    path: '/ckEditorTest',
    exact: true,
    title: 'CK Classic Editor Test',
    component: CKEditorForm,
    hasParams: false,
    text: 'CK Classic Editor Test',
    securityKey: ""
  },

  //Financials
  {
    id: 'xeroBatchExtraction',
    path: '/xeroBatchExtraction',
    exact: true,
    title: 'Xero Batch Extraction',
    component: XeroBatchExtraction,
    hasParams: false,
    text: 'Xero Batch Extraction',
    securityKey: ""
  },
  {
    id: 'transactionReport',
    path: '/transactionReport',
    exact: true,
    title: 'Transaction Report',
    component: TransactionReport,
    hasParams: false,
    text: 'Transaction Report',
    securityKey: ""
  },
  {
    id: 'createEvent',
    path: '/createEvent',
    exact: true,
    title: 'Create Events',
    component: EventManagement,
    hasParams: false,
    text: 'Create Events',
    securityKey: ""
  },
  {
    id: 'viewEditEvent',
    path: '/viewEditEvent',
    exact: true,
    title: 'View / Edit Event',
    component: ViewEditEventManagement,
    hasParams: false,
    text: 'View Edit Event',
    securityKey: ""
  },
  {
    id: 'eventRegistrationApproval',
    path: '/eventRegistrationApproval',
    exact: true,
    title: 'Event Registration Approval',
    component: EventRegistrationApproval,
    hasParams: false,
    text: 'View Edit Event',
    securityKey: ""
  },
  {
    id: 'eventFeedbackQuestion',
    path: '/eventFeedbackQuestion',
    exact: true,
    title: 'View / Edit Entries',
    component: EventFeedbackQuestion,
    hasParams: false,
    text: 'Event Feedback Question',
    securityKey: ""
  },
  {
    id: 'eventQuestionAnswer',
    path: '/eventQuestionAnswer',
    exact: true,
    title: 'View / Edit Entries',
    component: EventQuestionAnswer,
    hasParams: false,
    text: 'Event Question Answer',
    securityKey: ""
  },
  {
    id: 'createAccount',
    path: '/createAccount',
    exact: true,
    title: 'Create Account',
    component: AccountManagement,
    hasParams: false,
    text: 'Create Account',
    securityKey: ""
  },
  {
    id: 'viewEditAccount',
    path: '/viewEditAccount',
    exact: true,
    title: 'View Account',
    component: ViewAccountTaskList,
    hasParams: false,
    text: 'Create Account',
    securityKey: ""
  },
  {
    id: 'gmpTaskList',
    path: '/gmpTaskList',
    exact: true,
    title: 'View GMP Course Provider/Event',
    component: GmpCourseProviderApplicationTaskList,
    hasParams: false,
    text: 'View GMP Course Provider/Event',
    securityKey: ""
  },
  {
    id: 'gmpCourseTaskList',
    path: '/gmpCourseTaskList',
    exact: true,
    title: 'View Course Provider',
    component: GmpCourseTaskList,
    hasParams: false,
    text: 'View Course Provider',
    securityKey: ""
  },
  {
    id: 'attendanceSubmissionList',
    path: '/attendanceSubmissionList',
    exact: true,
    title: 'Approve Attendance Submission',
    component: AttendanceSubmissionApprovalList,
    hasParams: false,
    text: 'Approve Attendance Submission',
    securityKey: ""
  },
  {
    id: 'editCourseProvider',
    path: '/editCourseProvider',
    exact: true,
    title: 'GMP Course Provider Application Task List',
    component: GmpCourseProviderTaskListApplication,
    hasParams: false,
    text: 'Create GMP Course',
    securityKey: ""
  },
  {
    id: 'editCourseProvider',
    path: '/editCourseProvider/:id',
    exact: true,
    title: 'GMP Course Provider Application Task List',
    component: GmpCourseProviderTaskListApplication,
    hasParams: false,
    text: 'Create GMP Course',
    securityKey: ""
  },
  {
    id: 'editCourse',
    path: '/editCourse/:courseId',
    exact: true,
    title: 'GMP Course Provider',
    component: EditGMPCourse,
    hasParams: false,
    text: 'Create GMP Course',
    securityKey: ""
  },
  {
    id: 'editCpdEvent',
    path: '/editCpdEvent/:id',
    exact: true,
    title: 'Cpd Event Application Task List',
    component: CpdEventApplication,
    hasParams: false,
    text: 'Create GMP Course',
    securityKey: ""
  },
  {
    id: 'committeApprovalList',
    path: '/committeApprovalList',
    exact: true,
    title: 'Committee Approval List',
    component: CommitteApprovalManagement,
    hasParams: false,
    text: 'Committee Approval List',
    securityKey: ""
  },
  //Committee List

  {
    id: 'committeeApprovalAssignment',
    path: '/committeeApprovalAssignment/:id',
    exact: true,
    title: 'Committee Approval Assignment',
    component: CommitteeApprovalAssignment,
    hasParams: false,
    text: 'Committee Approval Assignment',
    securityKey: ""
  },

  {
    id: 'committeeBatchApproval',
    path: '/committeeBatchApproval/:id',
    exact: true,
    title: 'Committee Batch Approval',
    component: CommitteeBatchApproval,
    hasParams: false,
    text: 'Committee Batch Approval',
    securityKey: ""
  },

  {
    id: 'viewCommitteeBatchApproval',
    path: '/viewCommitteeBatchApproval/:id',
    exact: true,
    title: 'View Committee Batch Approval',
    component: ViewCommitteeBatchApproval,
    hasParams: false,
    text: 'View Committee Batch Approval',
    securityKey: ""
  },

  {
    id: 'cpdAttendance',
    path: '/cpdAttendance/:id',
    exact: true,
    title: 'View CPD Attendance',
    component: ViewCpdAttendance,
    hasParams: false,
    text: 'View CPD Attendance',
    securityKey: ""
  },

  {
    id: 'createManualAccount',
    path: '/createManualAccount',
    exact: true,
    title: 'Create Manual Account',
    component: CreateManualAccount,
    hasParams: false,
    text: 'Create Manual Account',
    securityKey: ""
  },

  {
    id: 'viewManualAccount',
    path: '/viewManualAccount/:id',
    exact: true,
    title: 'View Manual Account',
    component: ViewManualAccount,
    hasParams: false,
    text: 'View Manual Account',
    securityKey: ""
  },
  {
    id: 'viewManualAccountList',
    path: '/viewManualAccountList',
    exact: true,
    title: 'View Manual Account List',
    component: ViewManualAccountList,
    hasParams: false,
    text: 'View Manual Account List',
    securityKey: ""
  },
  {
    id: 'verifiedCompetency',
    path: '/verifiedCompetency',
    exact: true,
    title: 'Verified Competency',
    component: VerifiedCompetency,
    hasParams: false,
    text: 'Verified Competency',
    securityKey: ""
  },
  {
    id: 'addVerifiedCompetency',
    path: '/addVerifiedCompetency',
    exact: true,
    title: 'Add Verified Competency',
    component: AddVerifiedCompetency,
    hasParams: false,
    text: 'Add Verified Competency',
    securityKey: ""
  },
  {
    id: 'verifiedCompetencySubmission',
    path: '/verifiedCompetencySubmission/:editId',
    exact: true,
    title: 'Verified Competency Submission',
    component: VerifiedCompetencySubmission,
    hasParams: false,
    text: 'Verified Competency Submission',
    securityKey: ""
  },
  {
    id: 'addManualAttendance',
    path: '/addManualAttendance',
    exact: true,
    title: 'Add Manual Attendance',
    component: AddManualAttendance,
    hasParams: false,
    text: 'Add Manual Attendance',
    securityKey: ""
  },

  // Green Mark Project
  {
    id: 'greenMarkProject',
    path: '/greenMarkProject',
    exact: true,
    title: 'Green Mark Project',
    component: GreenMarkProject,
    hasParams: false,
    text: 'Green Mark Project',
    securityKey: ""
  },
  {
    id: 'editGreenMarkProject',
    path: '/editGreenMarkProject/:id',
    exact: true,
    title: 'Edit Green Mark Project',
    component: EditGmProject,
    hasParams: false,
    text: 'Green Mark Project',
    securityKey: ""
  },
  
];
